export const schema = {
  impactCards: {
    wind_survey: [
      {
        name: "No Impact",
        definition: `
        <b>No Damage</b> <br>
        The structure is unaffected. No structural repairs are required. 
        `,
        example: `Roof, windows, doors, walls and foundation remain intact.`,
        guidance: /* html */ ` 
        The following criteria are met: 
        <ol>
          <li>
            All roof resiliency features are present <u>AND</u> roof is in “good” condition;  <b>AND</b>
          </li>
          <li>
            All window and door resiliency features are present <span style="text-decoration: underline;">AND</span> windows and doors are in “good" condition; <b>AND</b></li>
          <li>Walls and foundation are in “good" condition.</li>
        </ol>
        `,
        class: "grey lighten-5",
        backgroundColor: "rgba(0 ,0, 0 ,.5)",
      },
      {
        name: "Minor Impact",
        definition: `<b>No Significant Damage </b> <br>
        The structure is useable and can be occupied. Repairs required are minimal. `,
        example: `Roof remains intact; however, some windows or exterior doors are shattered/broken.`,
        guidance: /* html */ ` 
        The following criteria are met:
        <ol>
          <li>All roof resiliency features are present <span style="text-decoration: underline;">AND</span> roof is in “good” condition; <b>AND</b></li>
          <li>
          All <span style="text-decoration: underline;">core</span> window and <span style="text-decoration: underline;">core</span> door resiliency features are present <span style="text-decoration: underline;">AND</span> windows and doors are in “good" condition; <b>AND</b>
          </li>
          <li>Walls and foundation are in “fair” or “good” condition.</li>
        </ol>
       
        `,
        class: "light-blue",
        backgroundColor: "rgba(3 ,169, 244 ,1)",
      },
      {
        name: "Moderate Impact",
        definition: `<b>Moderate Damage</b> <br>
          The structure is useable and can be occupied after urgent, temporary measures are taken. The owner will probably need assistance with repairs.
          `,
        example: `Portions of roof covering or a small section of the roof structure is missing. Some windows or exterior doors are blown out. `,
        guidance: /* html */ `
        The following criteria are met:
        <ol>
          <li>
          <span >All <span style="text-decoration: underline;">core</span> roof </span><span>resiliency features </span><span>are present</span>
          (but any other roof resiliency feature is missing) AND roof is in “fair” or “good” condition <span style="text-decoration: underline;">OR</span> all roof resiliency features are present AND roof is in “fair” condition; <strong>AND/OR</strong>
          </li>
          <li>
          <span style="text-decoration: underline;">Core</span> window or <span style="text-decoration: underline;">core</span> door resiliency features are missing <span style="text-decoration: underline;">OR</span> windows or doors are in “fair” condition; <strong>AND</strong>
          </li>
          <li>Walls and foundation are in “fair” or “good” condition.</li>
        </ol>
                `,
        class: "amber",
        backgroundColor: " rgba(255, 193 ,7, 1)",
      },
      {
        name: "Major Impact",
        definition: `
        <b>Major damage</b> <br>
        The structure is not usable and cannot be occupied until after repairs are made.`,
        example: /* html */ `
        A large portion or all of the roof structure is blown off, exposing the interior of the house. Most windows or exterior doors are shattered/broken or blown out. Walls may be damaged or the structure may be shifted off the foundation. 
        `,
        guidance: /* html */ `
        The following criteria are met: <br>
        <b>Scenario 1</b> 
        <ol>
          <li>
            At least one <u>core</u> roof resiliency feature is missing <u>OR</u> roof is in “poor” condition.  
          </li>
        </ol>
        <b>Scenario 2</b> 
        <ol>
        <li>
        At least one <span style="text-decoration: underline;">core</span> roof resiliency feature is missing <span style="text-decoration: underline;">OR</span> roof is in “poor” condition; <strong>AND</strong>
        </li>
        <li>
        <span style="text-decoration: underline;">Core</span> window or <span style="text-decoration: underline;">core</span> door resiliency features are missing <span style="text-decoration: underline;">OR</span> windows or doors are in “poor" condition; <strong>AND</strong>
        </li>
        <li> Walls and foundation are in “fair” or “good” condition.</li>
        </ol>

        `,
        class: "orange",
        backgroundColor: "rgba(255 ,152, 0,1)",
      },
      {
        name: "Extreme Impact",
        definition: `
        <b>Destroyed </b> <br>
        The structure is not useable and cannot be repaired. The structure must be rebuilt. 
        `,
        example: `The entire structure is destroyed - total destruction.`,
        /* html */
        guidance: `
        The following criteria are met:
        <ol>
          <li>
          At least one <span style="text-decoration: underline;">core</span> roof resiliency feature is missing <span style="text-decoration: underline;">OR</span> roof is in “poor” condition; <strong>AND</strong>
          </li>
          <li>
          <span style="text-decoration: underline;">Core</span> window or <span style="text-decoration: underline;">core</span> door resiliency features are missing <span style="text-decoration: underline;">OR</span> windows or doors are in “poor" condition <strong>AND/OR</strong>
          </li>
          <li>Walls or foundation is in “poor" condition.</li>
        </ol>
        `,
        class: "red",
        backgroundColor: "rgba(244, 67, 54, 1)",
      },
    ],
    flood_survey: [
      {
        name: "No Impact",
        definition: `
        <b>No Damage </b> <br>
        The structure and home contents are unaffected. No repairs are required. 
        `,
        example: "There is no water intrusion.",
        guidance: `Select if your home experienced no damage from the 2013 Christmas Eve Trough or if improvements since or home features justify this selection. `,
        class: "grey",
        backgroundColor: "#444",
      },
      {
        name: "Minor Impact",
        definition: `
        <b>No Significant Damage</b> <br>
        The structure is useable and can be occupied. Repairs required are minimal.`,
        /* html */
        example: `There is minimal water intrusion/entry, resulting in no pooling of water. No significant damage to fixtures, furnishings or personal items is present. No damage to electricals is present. No undermining/
         erosion of the foundation is present. 
        `,
        guidance: `Select if your home experienced minor damage from the 2013 Christmas Eve Trough or if changes since or home features justify this selection. `,
        class: "light-blue",
        backgroundColor: "rgba(3 ,169, 244 , 1)",
      },
      {
        name: "Moderate Impact",
        definition: `
        <b>Moderate Damage</b> <br>
        The structure is useable and can be occupied after urgent temporary measures are taken. The owner will probably need assistance with repairs.
        `,
        example: `There is moderate water intrusion/entry, resulting in water pooling less than 2-3 feet. Some damage to fixtures, furnishings and personal items is present. Minor undermining/
        erosion of the foundation is present. 
        `,
        guidance: `Select if your home experienced moderate damage from the 2013 Christmas Eve Trough or if changes since or home features justify this selection.`,
        class: "amber",
        backgroundColor: " rgba(255, 193 ,7, 1)",
      },
      {
        name: "Major Impact",
        definition: `
        <b>Major damage</b> <br>
        The structure is not usable and cannot be occupied until after repairs are made. 
        `,
        example: `There is major water intrusion/entry, resulting in water pooling more than 2-3 feet. Major damage to fixtures, furnishings and personal items is present. Major undermining/
        erosion of the foundation is present. Water ingress in electrical conduits, fixtures and panels is present. 
        `,
        guidance: `Select if your home experienced major damage from the 2013 Christmas Eve Trough or if changes since or home features justify this selection.`,
        class: "orange",
        backgroundColor: "rgba(255 ,152, 0, 1)",
      },
      {
        name: "Extreme Impact",
        /* html */
        definition: `<b>Destroyed </b><br>
        The structure is not useable. The structure must be rebuilt or requires major structural repairs.         
        `,
        example: `There is major water intrusion/entry, resulting in major structural damage or the structure being washed away by flood waters. `,
        guidance: `Select if your home experienced extreme damage from the 2013 Christmas Eve Trough or if changes since or home features justify this selection.`,
        class: "red",
        backgroundColor: "rgba(244, 67, 54, 1)",
      },
    ],
    water_survey: [
      {
        name: "Minor Impact",
        definition: /* html */ `
        <b>No Significant Impact</b><br>
        Access to water for all essential and non-essential household demands CAN be maintained through safe, 
        independent storage supplies for 2 weeks.
`,
        example: /* html */ `
        Normal water conservation measures are sufficient. No interruption to household function and no impact on household sanitation is expected. 
        `,
        /* html */
        guidance: `Select if you can store enough water to meet all essential and non-essential household demands for 2 weeks.`,
        class: "light-blue",
        backgroundColor: "rgba(3 ,169, 244 , 1)",
      },
      {
        name: "Moderate Impact",
        /* html */
        definition: `<b>Minor Impact</b><br>
          Access to water for all essential household needs (showering, flushing toilets, personal hygiene, cleaning surfaces, cooking) CAN be maintained through safe, independent storage supplies for 2 weeks. 
        `,
        example: /* html */ `
        Extra water conservation measures are required. Minor interruption to household function but no impact on household sanitation is expected.`,
        guidance: `Select if you can store enough water to meet all essential household demands for 2 weeks`,
        class: "amber",
        backgroundColor: "rgba(255, 193 ,7 , 1)",
      },
      {
        name: "Major Impact",
        /* html */
        definition: `<b>Major Impact</b> <br>
          Access to water for all essential household needs (showering, flushing toilets, personal hygiene, cleaning surfaces, cooking) CANNOT be maintained through safe, independent storage supplies for 2 weeks
        `,
        example: `Severe water rationing is required. There is major interruption to household function and household sanitation is compromised.`,
        guidance: `Select if you cannot store enough water to meet all essential household demands for 2 weeks.`,
        class: "orange",
        backgroundColor: "rgba(255 ,152, 0 ,1)",
      },
      {
        name: "Extreme Impact",
        definition: `<b>Temporarily Uninhabitable </b><br>
           There is no access to water for essential household needs.`,
        example: `There is no access to water. The household cannot function and major sanitation risks arise, forcing temporary abandonment of the home. `,
        guidance: `Select if no water storage tank or cistern is present at your home.`,
        class: "red",
        backgroundColor: "rgba(244, 67, 54, 1)",
      },
    ],
  },
};
